export default class Sky extends Phaser.Group {
  constructor({ game, data }) {
    super(game);

    this.data = data;

    this.day = this.game.make.group();
    this.night = this.game.make.group();
    this.night.alpha = 0;
    this.addChild(this.day);
    this.addChild(this.night);

    let x = 0;
    do {
      let img = this.game.make.image(x, 0, data.key_day);
      this.day.addChild(img);
      img = this.game.make.image(x, 0, data.key_night);
      this.night.addChild(img);

      x += img.width;
    } while (x < data.width);
  }

  get width() {
    return this.data.width;
  }

  setDay() {
    this.game.add.tween(this.night).to({ alpha: 0 }, 500, null, true);
  }

  setNight(instant) {
    if (instant) {
      this.night.alpha = 1;
    } else {
      this.game.add.tween(this.night).to({ alpha: 1 }, 500, null, true);
    }
  }
}
